import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ExamPaymentPage from './pages/ExamPaymentPage';
import ExamThankYouPage from './pages/ExamThankYouPage';
import PrescriptionPaymentPage from './pages/PrescriptionPaymentPage';
import PrescriptionThankYouPage from './pages/PrescriptionThankYouPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/exam/payment' element={<ExamPaymentPage />} />
        <Route path='/exam/thankYou' element={<ExamThankYouPage />} />
        <Route
          path='/prescription/payment'
          element={<PrescriptionPaymentPage />}
        />
        <Route
          path='/prescription/thankYou'
          element={<PrescriptionThankYouPage />}
        />
      </Routes>
    </Router>
  );
}

export default App;
